import {Reducer} from "redux";
import { ClientIpoCampaignAction, ClientIpoCampaignActionType, ICallbackGetCustomerByClientIpoCampaignPageAction} from "../action/client_ipo_campaign";
import { ClientIpoCampaignState } from "../store/client_ipo_campaign_store";

const initialState: ClientIpoCampaignState = {
    ipoPrepCustomers: [],
    internalControlCustomers: [],
    auditCustomers: [],
    securitiesAuditCustomers: [],
    fundraisingCustomers: [],
    irStrategyCustomers: [],
    investorRelationsCustomers: [],
    materialsCustomers: [],
    globalCustomers: [],
    cfoCustomers: [],
    jobCareersWithCustomerID: [],
    clientBookmarks: [],
    isLoading: false,
};

const clientIpoCampaignReducer: Reducer<ClientIpoCampaignState> = (state = initialState, action: ClientIpoCampaignAction): ClientIpoCampaignState => {
    switch (action.type) {

        case ClientIpoCampaignActionType.REQUEST_GET_CUSTOMERS: {
            return Object.assign({}, state, {
                isLoading: true,
            });
        }
        case ClientIpoCampaignActionType.CALLBACK_GET_CUSTOMERS: {
            const _action = action as ICallbackGetCustomerByClientIpoCampaignPageAction;
            if (action.isSuccess) {
                return Object.assign({}, state, {
                    ipoPrepCustomers: (_action.item) ? _action.item.ipoPrepCustomers : [],
                    internalControlCustomers: (_action.item) ? _action.item.internalControlCustomers : [],
                    auditCustomers: (_action.item) ? _action.item.auditCustomers : [],
                    securitiesAuditCustomers: (_action.item) ? _action.item.securitiesAuditCustomers : [],
                    fundraisingCustomers: (_action.item) ? _action.item.fundraisingCustomers : [],
                    irStrategyCustomers: (_action.item) ? _action.item.irStrategyCustomers : [],
                    investorRelationsCustomers: (_action.item) ? _action.item.investorRelationsCustomers : [],
                    materialsCustomers: (_action.item) ? _action.item.materialsCustomers : [],
                    globalCustomers: (_action.item) ? _action.item.globalCustomers : [],
                    cfoCustomers: (_action.item) ? _action.item.cfoCustomers : [],
                    jobCareersWithCustomerID: (_action.item) ? _action.item.jobCareersWithCustomerID : [],
                    clientBookmarks: (_action.item) ? _action.item.clientBookmarks : [],
                    isLoading: false,
                });
            } else {
                return Object.assign({}, state, {
                    isLoading: false,
                });
            }
        }

        default:
            return state;
    }
};

export default clientIpoCampaignReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/client_ipo_campaign_reducer.ts